// validate-endpoint-host-allowlist.ts
//
// Shared host-allowlist gate cho các endpoint nhận credentials (id_token,
// refresh_token, device_code) qua override (env / settings.json). Trước đây
// supabase-pack-downloader.ts và resolve-auth-device-endpoint.ts mỗi file tự
// định nghĩa const allowlist + check suffix riêng (byte-identical duplication)
// — gộp lại đây để tránh 2 nơi lệch nhau khi cần siết/nới allowlist.
//
// exactHosts: match chính xác (vd project Supabase cụ thể — KHÔNG trust
// subdomain khác vì attacker có thể tạo project Supabase riêng dạng
// *.supabase.co để MITM).
// suffixHosts: match subdomain của domain NAL sở hữu (vd ".nal.vn",
// ".nal-software.com") — an toàn vì domain do NAL kiểm soát, không multi-tenant.
export interface EndpointHostAllowlist {
  exactHosts: string[];
  suffixHosts?: string[];
}

// Callback tạo error đúng type/message caller đang dùng (PackParseError vs
// Error thường) — giữ nguyên hành vi throw hiện có ở từng call site.
export function assertAllowedEndpointHost(
  host: string,
  allowlist: EndpointHostAllowlist,
  createError: (message: string) => Error,
): void {
  const normalizedHost = host.toLowerCase();
  const exactMatch = allowlist.exactHosts.some((h) => normalizedHost === h.toLowerCase());
  const suffixMatch = (allowlist.suffixHosts ?? []).some((suffix) => {
    const normalizedSuffix = suffix.toLowerCase();
    return (
      normalizedHost === normalizedSuffix.replace(/^\./, "") ||
      normalizedHost.endsWith(normalizedSuffix)
    );
  });
  if (!exactMatch && !suffixMatch) {
    const allowedDescription = [...allowlist.exactHosts, ...(allowlist.suffixHosts ?? [])].join(
      ", ",
    );
    throw createError(
      `host không được phép: ${normalizedHost}. Chỉ chấp nhận: ${allowedDescription}. ` +
        `Từ chối gửi credentials tới host lạ.`,
    );
  }
}
